// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/compass-swinging.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/compass-swinging/compass-swinging.js';

mount([g0]);
